module.exports = __webpack_public_path__ + "img/charter-2.16bce0d.png";